import { useRef, useState } from 'react';
import { Button } from 'tdesign-react';
import { useNavigate } from 'react-router-dom';
import SubmitTab from './SubmitTab';
import HistoryTab, { type HistoryTabHandle } from './HistoryTab';
import { clearPortalAuth, getPortalToken } from '@/utils/auth';
import { usePortalAccount } from '@/contexts/PortalAccountContext';
import './Portal.css';

type TabKey = 'submit' | 'history';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'submit', label: '提交指令' },
  { key: 'history', label: '历史记录' },
];

const Portal = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState<TabKey>('submit');
  const historyRef = useRef<HistoryTabHandle>(null);
  // account 从内存 Context 读取，避免用户在 localStorage 伪造身份影响前端逻辑
  const { account, setAccount } = usePortalAccount();
  // 仅"前端微信登录用户"才有退出登录的概念；后台太湖用户登出走太湖
  const isPortalUser = !!getPortalToken();

  const handleSubmitted = () => {
    setActive('history');
    setTimeout(() => historyRef.current?.refresh(), 0);
  };

  const handleLogout = () => {
    clearPortalAuth();
    setAccount(null);
    navigate('/portal/login', { replace: true });
  };

  return (
    <div className="portal-page">
      <div className="portal-inner">
        <div className="portal-header-bar">
          <div className="portal-header-user">
            {account ? (
              <>
                <span className="portal-header-name">
                  {account.name || account.nickname || '-'}
                </span>
                <span className="portal-header-org">{account.organization || ''}</span>
              </>
            ) : null}
          </div>
          {isPortalUser ? (
            <Button variant="text" size="small" onClick={handleLogout}>
              退出登录
            </Button>
          ) : null}
        </div>

        <div className="portal-tabs">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              className={`portal-tab ${active === t.key ? 'active' : ''}`}
              onClick={() => setActive(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {active === 'submit' ? (
          <SubmitTab onSubmitted={handleSubmitted} />
        ) : (
          <HistoryTab ref={historyRef} />
        )}
      </div>
    </div>
  );
};

export default Portal;
